import {  useState, useEffect  } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const CookieNotice = () => {
  const [accepted, setAccepted] = useLocalStorage('cookiesAccepted', false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!accepted) setShow(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [accepted]);

  const handleAccept = () => {
    setAccepted(true);
    setShow(false);
    // Consent given — GA can now track enhanced events
    try {
      const g = (window as any).gtag;
      if (typeof g === 'function') {
        // Update consent state in GA
        g('consent', 'update', {
          'analytics_storage': 'granted'
        });
        g('event', 'consent_accepted');
      }
    } catch {}
  };

  if (!show || accepted) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 dark:bg-gray-900/95 p-4 shadow-lg dark:shadow-gray-950/50 z-50 border-t border-gray-100 dark:border-gray-800 backdrop-blur-lg">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-700 dark:text-gray-300">
          We use cookies to enhance your experience and analyze our traffic. By continuing, you accept our use of cookies.
        </p>
        <button
          onClick={handleAccept}
          className="whitespace-nowrap px-4 py-2 bg-indigo-600 dark:bg-indigo-500 text-white rounded-lg hover:bg-indigo-700 dark:hover:bg-indigo-600 transition-colors"
        >
          Accept
        </button>
      </div>
    </div>
  );
};